import axios from 'axios'
import { addURLParams } from '../tools/URLTools';
import { showLoading, hideLoading } from '../loading/GlobalLoading';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import { useTokenStore } from '../store/TokenStore';
import { v4 as uuidv4 } from 'uuid'
import { sm3Encode } from '../utils/sm3';
import { whiteName } from '../router/RouterMap';
axios.defaults.withCredentials = true;

const P_CODE = 'ayyy';

let out = 0;

function processNetError(response) {
    if (response.status && response.status == 200) {
    } else {
        return true
    }
}
function serviceErr(err) {
    ElNotification({
        title: '服务错误',
        message: '检查您的网络连接是否稳定',
        type: 'error',
    })
}
function processServiceError(data) {
    if (/6666/.test(data.code)) {
        return false
    }
    if (data.code != '200') {
        
        if (data.code == '401') {
            // goto login
            if (out == 1) return;
            out = 1;
            const tokenStore = useTokenStore();
            console.log(window.location)
            const pathHash = window.location.hash.replace('#','')
            if(pathHash.indexOf('tataweb') == -1){
                if (!whiteName.includes(pathHash)) {
                    localStorage.clear()
                    sessionStorage.clear()
                    // enterUrl('/tatweb/post')
                    window.location.href = window.location.origin + "/"
                } else {
                    localStorage.clear()
                    sessionStorage.clear()
                    window.location.reload();
                    // window.location.href = window.location.origin + "/#" + route.path;
                }
            }else{
                ElMessageBox.alert('登录已过期，请重新登录', '提示：', {
                    // if you want to disable its autofocus
                    // autofocus: false,
                    confirmButtonText: '确定',
                    callback: (action) => {
                        axios.get('/configs/login.json').then(res => {
                            localStorage.clear()
                            sessionStorage.clear()
                            tokenStore.setUserInfo(null);
                            if(window.location.hash.indexOf('tatweb')!=-1){
                                window.location.href = window.location.origin + '/login-manager.html'
                            }else{
                                window.location.href = window.location.origin + '/login.html'
                            }
                            // window.location.href = res.data.loginAddress
                        }).catch((e) => {
                            localStorage.clear()
                            sessionStorage.clear()
                            tokenStore.setUserInfo(null);
                            if(window.location.hash.indexOf('tatweb')!=-1){
                                window.location.href = window.location.origin + '/login-manager.html'
                            }else{
                                window.location.href = window.location.origin + '/login.html'
                            }
                            // window.location.href = '/login.html';
                        })
                    },
                })
            }
            // whiteName.includes(window.location.hash)
           
            return true
        }

        // ElNotification({
        //     title: '数据提交错误',
        //     message: data.msg,
        //     type: 'error',
        // })
        ElMessageBox.alert(data.msg, '温馨提示：');
        return true;
    }
    return false;
}
function processResponse(data) {
    // console.log(processServiceError(data))
    if (processServiceError(data)) {
        return -1;
    }
    return data;
}
const REQ_SOURCE_MAP = new Map();
const REQ_STACK = new Map();
const REQ_LOADING = new Map();


export async function remoteCall(url, config, overlap = false) {
    // url = addURLParams(url, { pcode: P_CODE })

    const tokenStore = useTokenStore();
    // if (!tokenStore.token) return;
    const params = config.params;
    const data = config.data;
    // tools.filterParamsFn(data)
    var p = new Promise(function (resolve) {
        setTimeout(function () { resolve(undefined) }, 0);
    }).then(
        function (value) {
            REQ_LOADING.set(url, true);
            const stack = REQ_STACK.get(url);
            // console.log(url, !stack)
            // if (!stack) return null;
            if (stack && (stack.length == 1 || stack[0] == p)) {
                REQ_STACK.delete(url);
                // console.log('last', overlap, url);
                showLoading(config.loadingState);
                let source = REQ_SOURCE_MAP.get(url);

                //重复的先不 cancel
                // if (source) source.cancel();

                const CancelToken = axios.CancelToken;
                source = CancelToken.source();
                REQ_SOURCE_MAP.set(url, source);

                let cancelHandler = null;
                (function (source) {
                    cancelHandler = setTimeout(function () {
                        source.cancel();
                        ElMessage.error('无法连接远程服务，请检查网络连接')
                    }, 30000)
                })(source)

                if (params != null) url = addURLParams(url, params);
                const timestamp = Date.now()

                let dataStr = '{}'
                if (config.params) {
                    // config.params = convertdata(config.params)
                    dataStr = JSON.stringify(config.params)

                } else {
                    if (config.data) {
                        // config.data = convertdata(config.data)
                        dataStr = JSON.stringify(config.data)
                    }
                }
                // console.log(config, "dataStr")
                // let obj = {
                //     name: "jktyqlzmxt"
                // }
                let objdata = {
                    data: dataStr
                }
                // dataStr = JSON.stringify(obj)
                dataStr = dataStr.replace(/\"/g, '')
                let dataStr1 = JSON.stringify(objdata)
                dataStr1 = dataStr1.replace(/\"/g, '')
                const sign = 'Timestamp' + timestamp + dataStr
                // sign = sign.replace(/\"/g, '')
                const sign1 = 'Timestamp' + timestamp + dataStr1

                let urlKey = {
                    url: config.url
                }
                let urlKeys = JSON.stringify(urlKey)

                urlKeys = urlKeys.replace(/\"/g, '')
                const signUrl = 'Timestamp' + timestamp + urlKeys
                const timestampStr = timestamp
                const nonceStr = shortUuid()
                let configheaders = {
                    'X-Ca-Sign': sm3Encode(sign).toUpperCase(),
                    'X-Ca-Timestamp': timestampStr,
                    'X-Ca-Datasign': sm3Encode(sign1).toUpperCase(),
                    'X-Ca-Urlsign': sm3Encode(signUrl).toUpperCase(),
                    'X-Ca-Nonce': nonceStr,
                    'X-Ca-Nonce-TT': sm3Encode(timestampStr + nonceStr).toUpperCase()
                }
                if (config.type == 'delete') {

                    return axios.delete(url, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                } else if (data == null) {

                    return axios.get(url, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                } else if (config.type == 'put') {
                    return axios.put(url, data, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                } else {
                    return axios.post(url, data, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                }
            } else {
                // console.log('not last', overlap, url, stack);
                return overlap && stack ? stack[0] : null;
            }
        })
    var stack = REQ_STACK.get(url);
    if (!stack) {
        REQ_STACK.set(url, stack = []);
        stack.unshift(p);
    } else if (REQ_LOADING.get(url)) {
        return stack[0];
    } else {
        stack.unshift(p);
    }
    return p;
}
export async function noLoadingRemoteCall(url, config, overlap = false) {
    // url = addURLParams(url, { pcode: P_CODE })

    const tokenStore = useTokenStore();
    // if (!tokenStore.token) return;
    const params = config.params;
    const data = config.data;
    // tools.filterParamsFn(data)
    var p = new Promise(function (resolve) {
        setTimeout(function () { resolve(undefined) }, 0);
    }).then(
        function (value) {
            REQ_LOADING.set(url, true);
            const stack = REQ_STACK.get(url);
            // console.log(url, !stack)
            // if (!stack) return null;
            if (stack && (stack.length == 1 || stack[0] == p)) {
                REQ_STACK.delete(url);
                // console.log('last', overlap, url);
                let source = REQ_SOURCE_MAP.get(url);

                //重复的先不 cancel
                // if (source) source.cancel();

                const CancelToken = axios.CancelToken;
                source = CancelToken.source();
                REQ_SOURCE_MAP.set(url, source);

                let cancelHandler = null;
                (function (source) {
                    cancelHandler = setTimeout(function () {
                        source.cancel();
                        ElMessage.error('无法连接远程服务，请检查网络连接')
                    }, 30000)
                })(source)

                if (params != null) url = addURLParams(url, params);
                const timestamp = Date.now()

                let dataStr = '{}'
                if (config.params) {
                    // config.params = convertdata(config.params)
                    dataStr = JSON.stringify(config.params)

                } else {
                    if (config.data) {
                        // config.data = convertdata(config.data)
                        dataStr = JSON.stringify(config.data)
                    }
                }
                // console.log(config, "dataStr")
                // let obj = {
                //     name: "jktyqlzmxt"
                // }
                let objdata = {
                    data: dataStr
                }
                // dataStr = JSON.stringify(obj)
                dataStr = dataStr.replace(/\"/g, '')
                let dataStr1 = JSON.stringify(objdata)
                dataStr1 = dataStr1.replace(/\"/g, '')
                const sign = 'Timestamp' + timestamp + dataStr
                // sign = sign.replace(/\"/g, '')
                const sign1 = 'Timestamp' + timestamp + dataStr1

                let urlKey = {
                    url: config.url
                }
                let urlKeys = JSON.stringify(urlKey)

                urlKeys = urlKeys.replace(/\"/g, '')
                const signUrl = 'Timestamp' + timestamp + urlKeys
                const timestampStr = timestamp
                const nonceStr = shortUuid()
                let configheaders = {
                    'X-Ca-Sign': sm3Encode(sign).toUpperCase(),
                    'X-Ca-Timestamp': timestampStr,
                    'X-Ca-Datasign': sm3Encode(sign1).toUpperCase(),
                    'X-Ca-Urlsign': sm3Encode(signUrl).toUpperCase(),
                    'X-Ca-Nonce': nonceStr,
                    'X-Ca-Nonce-TT': sm3Encode(timestampStr + nonceStr).toUpperCase()
                }
                if (config.type == 'delete') {

                    return axios.delete(url, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                } else if (data == null) {

                    return axios.get(url, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                } else if (config.type == 'put') {
                    return axios.put(url, data, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                } else {
                    return axios.post(url, data, {
                        headers: {
                            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
                            ...configheaders
                            // 'hayden': tokenStore.token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjoyMDIyMDYxNH0.cfmWq4gI-LbB6_Y9bVZEriJNHbTJpBeWno8mBdApS6Q'
                            // 'hayden': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjAsImRldmljZSI6ImRlZmF1bHQtZGV2aWNlIiwiZWZmIjotMSwicm5TdHIiOiJrdEswU2NqR2xqajlIN0hOSFZqZ2hkMXdVSWFHZVZYRCIsInVzZXJuYW1lIjoi5p2O6L6JIiwicGhvbmVOdW1iZXIiOiIxNTU1NjUzMTk5MyIsInRlbmFudElkIjowfQ.2pYNxBZQrnPlskEWg4soCyA55wSBvMRKVgUJZqO4rzA'
                        }, cancelToken: source.token
                    }).then(function (response) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        const responseData = response.data;
                        if (processNetError(response)) {
                            return -1;
                        }
                        return processResponse(responseData);
                    }, function (err) {
                        hideLoading();
                        if (cancelHandler) clearTimeout(cancelHandler);
                        REQ_SOURCE_MAP.delete(url);
                        REQ_LOADING.delete(url);
                        if (err.message != 'canceled') serviceErr(err);
                        return -1;
                    })
                }
            } else {
                // console.log('not last', overlap, url, stack);
                return overlap && stack ? stack[0] : null;
            }
        })
    var stack = REQ_STACK.get(url);
    if (!stack) {
        REQ_STACK.set(url, stack = []);
        stack.unshift(p);
    } else if (REQ_LOADING.get(url)) {
        return stack[0];
    } else {
        stack.unshift(p);
    }
    return p;
}
export function getSign(url, params) {
    const timestamp = Date.now()
    let dataStr = '{}'
    if (params) {
        dataStr = JSON.stringify(params)

    }
    let objdata = {
        data: dataStr
    }
    dataStr = dataStr.replace(/\"/g, '')
    let dataStr1 = JSON.stringify(objdata)
    dataStr1 = dataStr1.replace(/\"/g, '')
    const sign = 'Timestamp' + timestamp + dataStr
    const sign1 = 'Timestamp' + timestamp + dataStr1
    let urlKey = {
        url: url
    }
    let urlKeys = JSON.stringify(urlKey)
    urlKeys = urlKeys.replace(/\"/g, '')
    const signUrl = 'Timestamp' + timestamp + urlKeys
    const timestampStr = timestamp
    const nonceStr = shortUuid()
    return {
        'X-Ca-Sign': sm3Encode(sign).toUpperCase(),
        'X-Ca-Timestamp': timestampStr,
        'X-Ca-Datasign': sm3Encode(sign1).toUpperCase(),
        'X-Ca-Urlsign': sm3Encode(signUrl).toUpperCase(),
        'X-Ca-Nonce': nonceStr,
        'X-Ca-Nonce-TT': sm3Encode(timestampStr + nonceStr).toUpperCase()
    }
}
export async function getFielBlod(download, resourceUri) {
    const url = download + '/' + btoa(resourceUri)
    const tokenStore = useTokenStore();
    return  axios.get(url, {
        headers: {
            'Authorization': 'Bearer ' + (tokenStore.token || 'eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze'),
            ...getSign(url, {})
            
        },
        responseType: 'blob'
    })
}

// const getUrlData = (link, data, res) => {
//     if (!link) return link;
//     link = link.replace(/[\?\&\#]([\w]+)\=\{([^\=\&]+)\}/g, (_, $1, $2) => {
//         const val = data[$2];
//         if (val != null) res[$1] = val;
//         return '';
//     })
//     link = link.replace(/[\?\&\#]([\w]+)\=([^\=\&]+)/g, (_, $1, $2) => {
//         const val = $2;
//         if (val != null) res[$1] = val;
//         return '';
//     })
//     return link;
// }
// export const formatDataUrl = (url, data) => {
//     const params = {};
//     const body = {};
//     url = url.replace(/(\?[^\#]+)|(\#[^\?]+)/g, (_, $1, $2) => {
//         const queryLink = $1;
//         const bodyLink = $2;
//         let res = '';
//         if (queryLink) res = getUrlData(queryLink, data, params);
//         if (bodyLink) res = getUrlData(bodyLink, data, body)
//         return res;
//     })
//     return {url:url, params:params, body:body};
// }

/**
 * 获取短uuid
 */
const chars = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
    't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
    'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
function shortUuid() {
    let shortBuffer = ''
    let uuidStr = uuidv4()
    uuidStr = uuidStr.replace(/-/g, '')
    for (var i = 0; i < 8; i++) {
        const str = uuidStr.substring(i * 4, i * 4 + 4)
        const x = parseInt(str, 16)
        shortBuffer += chars[x % 0x3E]
    }
    return shortBuffer
}